/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteText from './DyteText';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { States } from '..';
import { DyteI18n, useLanguage } from '../lib/lang';

import { useDyteSelector } from '@dytesdk/react-native-core';
import DyteClient from '@dytesdk/web-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  states,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  states?: States;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const joined = useDyteSelector((m) => m.participants.joined);
  const onStage = [...joined.toArray(), meeting.self].filter(
    (p) => p.stageStatus === 'ON_STAGE'
  );
  const pCount = useDyteSelector((m) => m.participants.count);
  const pageCount = useDyteSelector((m) => m.participants.pageCount);
  const currentPage = useDyteSelector((m) => m.participants.currentPage);
  const styles = StyleSheet.create({
    container: {
      margin: 4,
      flexDirection: 'row',
      alignItems: 'center',
    },
    buttonContainer: {
      flexDirection: 'row',
      backgroundColor: colors.background[900],
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 24,
    },
    currentPageText: {
      margin: 1,
      marginHorizontal: 4,
    },
    pageCountText: {
      marginTop: 4,
      marginRight: 4,
    },
    button: {
      padding: 6,
    },
  });
  const maxParticipantsOnScreen =
    meeting.self.config.maxVideoStreams.mobile ?? 6;
  if (
    meeting.meta.viewType === 'GROUP_CALL' &&
    joined.toArray().length < maxParticipantsOnScreen
  )
    return null;
  if (
    meeting.meta.viewType !== 'GROUP_CALL' &&
    onStage.length < maxParticipantsOnScreen
  )
    return null;
  return (
    <View style={styles.container}>
      <View style={styles.buttonContainer}>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          style={styles.button}
          onPress={() => {
            if (
              currentPage === 1 &&
              meeting.participants.viewMode === 'PAGINATED'
            )
              meeting.participants.setViewMode('ACTIVE_GRID');
            else {
              if (currentPage > 0)
                meeting.participants.setPage(currentPage - 1);
            }
          }}
        >
          <SvgXml
            xml={iconPack.chevron_left.replace('currentColor', colors.text)}
            width={18}
            height={18}
          />
        </TouchableHighlight>
        {meeting.participants.viewMode === 'ACTIVE_GRID' && (
          <SvgXml
            xml={iconPack.wand.replace('currentColor', colors.text)}
            width={18}
            height={18}
          />
        )}
        {meeting.participants.viewMode === 'PAGINATED' && (
          // eslint-disable-next-line react-native/no-inline-styles
          <View style={{ flexDirection: 'row' }}>
            <DyteText size="lg" style={styles.currentPageText}>
              {currentPage > 0 ? currentPage : 1}
            </DyteText>
            <DyteText size="sm" style={styles.pageCountText}>
              /{pageCount > 0 ? pageCount : 1}
            </DyteText>
          </View>
        )}
        <TouchableHighlight
          underlayColor={colors.background[800]}
          style={styles.button}
          onPress={() => {
            if (
              meeting.participants.viewMode === 'ACTIVE_GRID' &&
              pCount > maxParticipantsOnScreen - 1
            )
              meeting.participants.setViewMode('PAGINATED');
            else {
              if (currentPage < pageCount)
                meeting.participants.setPage(currentPage + 1);
            }
          }}
        >
          <SvgXml
            xml={iconPack.chevron_right.replace('currentColor', colors.text)}
            width={18}
            height={18}
          />
        </TouchableHighlight>
      </View>
    </View>
  );
}
